import KioskStatusesContainer from './kiosk-statuses-container';

export default KioskStatusesContainer;
